// sections/SectionAdditionalServices.jsx
import React from 'react';
import { Home } from 'lucide-react';
import { Row, Col, Select, SectionTitle, FormField, Textarea } from '../../../SharedInputs.jsx';

export function SectionAdditionalServices({ value, onChange, errors = [] }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div>
      <SectionTitle icon={Home} step={10}>Additional Support Services</SectionTitle>
      
      <Row>
        <Col span={6}>
          <FormField label="Would you like CIET to arrange homestay or accommodation assistance? ">
            <Select value={value.homestay} onChange={(e) => updateField('homestay', e.target.value)}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </Select>
          </FormField>
        </Col>
        <Col span={6}>
          <FormField label="Do you require airport pickup service?">
            <Select value={value.airportPickup} onChange={(e) => updateField('airportPickup', e.target.value)}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </Select>
          </FormField>
        </Col>
      </Row>
      {value.airportPickup === "Yes" && (
        <Row>
          <Col span={12}>
            <FormField 
              label="Airport pick up details"
              hint="If you selected airport pickup, please provide flight details, date/time of arrival"
              required={value.airportPickup === "Yes"}
              error={
                value.airportPickup === "Yes"
                  ? errors.find(err => err.toLowerCase().includes('airport pick up details'))
                  : undefined
              }
            >
              <Textarea
                value={value.arrivalDetails}
                onChange={(e) => updateField('arrivalDetails', e.target.value)}
                placeholder="Flight number, airline, arrival date/time, etc."
                required={value.airportPickup === "Yes"}
                error={
                  value.airportPickup === "Yes"
                    ? errors.find(err => err.toLowerCase().includes('airport pick up details'))
                    : undefined
                }
              />
            </FormField>
          </Col>
        </Row>
      )}

    </div>
  );
}